// Centralized lightweight logger respecting environment flags
import { featureFlags } from '@/utils/featureFlags';

type Level = 'debug' | 'info' | 'warn' | 'error';
interface LogOptions { force?: boolean; ctx?: Record<string, unknown>; }

const isEnabled = () => (import.meta.env.DEV || featureFlags.ff_runtime_debug === true);

function emit(level: Level, message: string, opts?: LogOptions) {
  if (!opts?.force && !isEnabled()) return;
  const parts: unknown[] = [message];
  if (opts?.ctx) parts.push(opts.ctx as unknown);
  try {
    (console[level] as (...args: unknown[]) => void)(...parts);
  } catch { /* noop */ }
}

export const logger = {
  debug: (m: string, o?: LogOptions) => emit('debug', m, o),
  info: (m: string, o?: LogOptions) => emit('info', m, o),
  warn: (m: string, o?: LogOptions) => emit('warn', m, o),
  error: (m: string, o?: LogOptions) => emit('error', m, o),
};

export default logger;
